/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'
import { GlobalDispatchContext } from '../context/GlobalContextProvider'

export const FORM_CODE_DEFAULT = '0'
export const FORM_CODE_ORIGINAL = '1' // the original form
export const FORM_CODE_MINIMAL = '2' // only one 'page' of forms
export const FORM_CODE_POSTCODE_API = '100' // new api to check for postcodes/addresses

const doSplitTest = false
const chanceOfChangingFormCode = 1

const overrideFormCode = (code) => {
  let newCode = code
  if (!newCode || newCode === FORM_CODE_DEFAULT) {
    // if the formCode was not provided (or is the default one) then map it to the new default behaviour
    newCode = FORM_CODE_POSTCODE_API
  }
  if (doSplitTest) {
    // TODO use this block to perform split tests and remap the form code randomly to something new
    // newCode = (Math.random() <= chanceOfChangingFormCode) ? *INSERT_NEW_CODE* : newCode
  }
  return newCode
}

const QueryParams = () => {
  const [testMode] = useQueryParam('tm', StringParam)
  const [formCode] = useQueryParam('fc', StringParam)

  const [source] = useQueryParam('utm_source', StringParam)
  const [medium] = useQueryParam('utm_medium', StringParam)
  const [campaign] = useQueryParam('utm_campaign', StringParam)
  const [content] = useQueryParam('utm_content', StringParam)

  const [campaignId] = useQueryParam('campaignid', StringParam)
  const [adgroupId] = useQueryParam('adgroupid', StringParam)
  const [creative] = useQueryParam('creative', StringParam)
  const [matchType] = useQueryParam('matchtype', StringParam)
  const [keyword] = useQueryParam('keyword', StringParam)

  const dispatch = useContext(GlobalDispatchContext)

  const newState = {
    testMode: testMode,
    formCode: overrideFormCode(formCode),

    source: source,
    medium: medium,
    campaign: campaign,
    content: content,

    campaignId: campaignId,
    adgroupId: adgroupId,
    creative: creative,
    matchType: matchType,
    keyword: keyword,
  }

  useEffect(() => {
    dispatch({ type: 'SET_QUERY_PARAMS', newState: newState })
  }, [])

  return <></>
}

export default QueryParams
